import { GENERAL_SETTING } from "../Actions/Utilites";

const INITIAL_STATE = {

    // Get 
    getGeneralSettingLoading: false,
    getGeneralSettingSuccess: false,
    getGeneralSettingFailure: false,
    getGeneralSettingError: null,
    getGeneralSettingDetail: null,
}

export const GeneralSettingReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        
        // Single GeneralSetting
        case GENERAL_SETTING.GET_GENERAL_SETTING_REQUEST:
            return {
                ...state,
                getGeneralSettingLoading: true,
                getGeneralSettingSuccess: false,
                getGeneralSettingFailure: false,
                getGeneralSettingError: null,
            };
        case GENERAL_SETTING.GET_GENERAL_SETTING_SUCCESS:
            return {
                ...state,
                getGeneralSettingLoading: false,
                getGeneralSettingSuccess: true,
                getGeneralSettingFailure: false,
                getGeneralSettingError: null,
                getGeneralSettingDetail: action.payload,
            };
        case GENERAL_SETTING.GET_GENERAL_SETTING_FAILURE:
            return {
                ...state,
                getGeneralSettingLoading: false,
                getGeneralSettingSuccess: false,
                getGeneralSettingFailure: true,
                getGeneralSettingError: action.payload,
            };

        default:
            return state;
    }
}